import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=00c2c2ad"
import script from "./divider.vue?vue&type=script&lang=js"
export * from "./divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports